import { User }          from '@app/modules/user/models/user.model';
import { Action }        from '@ngrx/store';
import { IManageTenant } from '@shared/content-sections/manage-tenant/manage-tenant.model';
import { ManagedObject } from '@shared/models/managed-object.model';

export enum ActionTypes {
	// LOGIN_REQUEST = '[Current User] Login Request',
	LOGIN_FAILURE = '[Current User] Login Failure',
	LOGIN_SUCCESS = '[Current User] Login Success',
	LOGOUT_REQUEST = '[Current User] Logout Request',
	LOGOUT_SUCCESS = '[Current User] Logout Success',
	LOGOUT_FAILURE = '[Current User] Logout Failure',
	MANAGE_TENANT_ACTIVE = '[Current User] Manage Tenant active',
	MANAGE_TENANT_INACTIVE = '[Current User] Manage Tenant inactive',
	SET_CURRENT_USER = '[Current User] Set Current User'
}

export class ManageTenantActive implements Action {
	readonly type = ActionTypes.MANAGE_TENANT_ACTIVE;

	constructor( public payload: IManageTenant ) {}
}

export class ManageTenantInactive implements Action {
	readonly type = ActionTypes.MANAGE_TENANT_INACTIVE;
}


export class LoginFailureAction implements Action {
	readonly type = ActionTypes.LOGIN_FAILURE;

	constructor( public payload: { error: string } ) {
	}
}

export class LoginSuccessAction implements Action {
	readonly type = ActionTypes.LOGIN_SUCCESS;

	constructor(
		public payload: {
			currentUser: User,
			currentUserId: string,
			isAuthenticated: boolean,
			managedObject: ManagedObject
			profile: object,
			roles: string[],
			tenantId: string,
		}
	) { }
}

export class LogoutRequestAction implements Action {
	readonly type = ActionTypes.LOGOUT_REQUEST;
}

export class LogoutFailureAction implements Action {
	readonly type = ActionTypes.LOGOUT_FAILURE;

	constructor( public error: string ) {
	}
}

export class LogoutSuccessAction implements Action {
	readonly type = ActionTypes.LOGOUT_SUCCESS;

	constructor( public payload: object ) {
	}
}


export class SetCurrentUserAction implements Action {
	readonly type = ActionTypes.SET_CURRENT_USER;

	constructor( public payload: User ) {}
}

export type Actions =
	LoginFailureAction |
	LoginSuccessAction |
	LogoutFailureAction |
	LogoutRequestAction |
	LogoutSuccessAction |
	ManageTenantActive |
	ManageTenantInactive |
	SetCurrentUserAction;
